module.exports = __webpack_public_path__ + "img/70.c54c3f8d.jpg";